let Tool = {};
const shareTitleArr = ['测一测你的社交安全距离','点击进入，测一测你的社交人设','点击这里>>>解锁你的社交人设！','你与我的距离，究竟有多远？','点击这里>>>发现你的社交人设'];
const shareDescArr = ['哇！你的社交人设竟然是？','2022，想好带谁一起出去玩了吗？','想坐我的车？先看看这个','远在天边，还是近在眼前，测一测就知道~','你的社交人设会是什么呢？'];
const pageTitleArr = ['社交安全距离大作战','测一测你的社交安全距离','测一测你的社交人设','来看看你的社交人设','生成你的社交人设'];

Tool.isDev = window.location.href.search(/d\.163\.com|192\.|127\.|10\./) > -1;
Tool.isTest = window.location.href.search(/http:\/\/test\.go\.163\.com/) >= 0;

Tool.pubPach = Tool.isDev ? "" : "dist/";

//parseInt(Math.random()*(4+1),10)
Tool.shareTitle = shareTitleArr[parseInt(Math.random()*(4+1),10)];
Tool.shareDesc = shareDescArr[parseInt(Math.random()*(4+1),10)];
Tool.pageTitle = pageTitleArr[parseInt(Math.random()*(4+1),10)];



Tool.urlData = {
    getUserInfo: (!Tool.isDev && !Tool.isTest)?'https://go.163.com/api/2022/0126/faw/common.php?act=getUserInfo':'/api/go/2022/0126/faw/common.php?act=getUserInfo',  //测试地址接口 
    wxIndex: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx41cc878a253b1ba2&redirect_uri=' + encodeURIComponent(location.href) + '&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect', // 授权链接
    addInfo: (!Tool.isDev && !Tool.isTest)?'https://go.163.com/api/2022/0126/faw/common.php?act=addInfo':'/api/go/2022/0126/faw/common.php?act=addInfo',
    getLists: (!Tool.isDev && !Tool.isTest)?'https://go.163.com/api/2022/0126/faw/common.php?act=getLists':'/api/go/2022/0126/faw/common.php?act=getLists',
    getStatus: (!Tool.isDev && !Tool.isTest)?'https://go.163.com/api/2022/0126/faw/common.php?act=getStatus':'/api/go/2022/0126/faw/common.php?act=getStatus',
};

Tool.wxLogin=function(){
    if(window.netease.ua.weixin && !Tool.isDev){
        localStorage.removeItem('sess');
        localStorage.removeItem('20220126_talagon');
        setTimeout(()=>{
            location.replace(Tool.urlData.wxIndex);
        },50);
    }
};

Tool.login=function(){
    console.log("login")
    if(window.netease.ua.weixin){
        return Tool.wxLogin();
    }
};

Tool.wxIsLogin=(function(){
    if(!localStorage.getItem('sess') || localStorage.getItem('sess') == "undefined"){
        localStorage.removeItem('sess');
    }
    if(!localStorage.getItem('userName') || localStorage.getItem('userName') == "undefined"){
        localStorage.removeItem('userName');
    }
    if(!localStorage.getItem('userHead') || localStorage.getItem('userHead') == "undefined"){
        localStorage.removeItem('userHead');
    }
    if(!localStorage.getItem('20220126_talagon') || localStorage.getItem('20220126_talagon') == "undefined"){
        localStorage.removeItem('20220126_talagon');
    }
    if(new Date().getTime() - localStorage.getItem('20220126_talagon') >= 2*60*60*1000-5*60*1000){
        localStorage.removeItem('20220126_talagon');
    }
    if(!localStorage.getItem('sess')||!localStorage.getItem('userName')||!localStorage.getItem('userHead')||!localStorage.getItem('20220126_talagon')){
        return false;
    }else{
        return true;
    }
})();

export default Tool;
